export default __webpack_public_path__ + "static/media/invictus_open_test_bannermobile.b8074e16.webp";